/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-04 15:33:39
 * @LastEditors: K
 * @LastEditTime: 2022-08-05 10:05:28
 */
/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-04 14:56:24
 * @LastEditors: K
 * @LastEditTime: 2022-08-04 15:11:00
 */
import { API_PREFIX } from './constant'
import { Request } from './request'

export interface getSendMessageListFnParams {
  templateName?: string
  startTime?: string
  endTime?: string
  current?: number
  size?: number
}
export function getSendMessageListFn(
  params: getSendMessageListFnParams
): Request {
  return {
    url: `${API_PREFIX}/blade-administer/smsrecord/list`,
    method: 'GET',
    params,
  }
}
